import React, { useState, useEffect } from "react";
import styled, { ThemeProvider } from "styled-components";
import { theme } from "../public/theme";
import { Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";

import { useSelector, shallowEqual, useDispatch } from "react-redux";

import {
  SG_GET_EMPLOYEE_SLACK,
  SG_GET_SLACK_SCHEDULER,
  SG_UPDATE_EMPLOYEE_SLACK,
} from "constants/actions";

import List from "./List";
import Details from "./Details";
import Create from "./Create"
import Edit from "./Edit"

const SlackScheduler = () => {
  const dispatch = useDispatch();
  const [slackUsers, setSlackUsers] = useState([]);
  const [internalUsers, setInternalUsers] = useState([]);
  const [mappings, setMappings] = useState([]);

  const { get_auth, get_organizations, get_employee, get_employee_slack } =
    useSelector(
      (state) => ({
        get_errors: state.errors,
        get_auth: state.auth,
        get_organizations: state.organizations,
        get_employee: state.employees,
        get_employee_slack: state.employee_slack,
      
      }),
      shallowEqual
    );


  const handleChangeMappings = (newMappings) => {
    setMappings(newMappings);
  };

  const handleConfirm = () => {
    // Handle the confirm and sync action
  };

  return (
    <ThemeProvider theme={theme}>
       <Header>
        <h1>Welcome to Slack Scheduler</h1>
      </Header>
      <Routes>
        <Route path="/" element={<List />} />
        <Route path="details/:id" element={<Details />} />
        <Route path="edit/:id" element={<Edit />} />
        <Route path="create" element={<Create />} />
        {/* <Route path="create" element={<Add setReload={setReload} />} /> */}
      </Routes>
     
    </ThemeProvider>
  );
};

export default SlackScheduler;

const Container = styled.div`
  padding: 20px;
  min-height: 10vh;
  margin-top: 30px;
`;

const LandingPage = styled.div`
  text-align: center;
`;

const Header = styled.header`
  background: ${(props) => props.theme.colors.primary};
  padding: 20px;
  color: white;
`;

const MainContent = styled.main`
  padding: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

const Th = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  background-color: #f2f2f2;
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
`;

const LinkButton = styled(Link)`
  display: inline-block;
  margin-top: 10px;
  margin-right: 10px;
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 5px;

  &:hover {
    background-color: #0056b3;
  }
`;